import countries from '../../../../json/countries.json'

export default (timetrialData, isDiscontinuation) => {

  const t = {
    data: timetrialData,
    isDiscontinuation
  }
  const init = () => {
    console.log('buildTimetrial', t.data);
    t.root = document.getElementById('timetrial');
    if (!t.root) {
      return;
    }
    buildTimetrialResultList(t.data.tt_result_list);
    buildTimetrialRaceVideo(t.data.tt_movie_yt_id);
  }

  const buildTimetrialResultList = (dataList) => {
    const rankClassNames = ['_first', '_second', '_third'];
    const rankList = document.querySelector('.le-rank__list');
    const rankListItem = rankList.firstElementChild;
    rankListItem.classList.remove(...rankClassNames);

    const fragment = document.createDocumentFragment();
    const imgLoadPromises = dataList.map(rankInfo => {
      return new Promise(resolve => {
        const cloneRankListItem = rankListItem.cloneNode(true);
        if (rankInfo.rank <= 3) {
          cloneRankListItem.classList.add(rankClassNames[rankInfo.rank - 1]);
        }

        cloneRankListItem.querySelector('._rank').textContent = rankInfo.rank;

        const thumbImg = cloneRankListItem.querySelector('.le-rank__thumb-img');
        thumbImg.addEventListener('load', () => {
          resolve();
        })
        thumbImg.addEventListener('error', () => {
          thumbImg.src = `/assets/images/league/under/timetrial/img_thumb_noimage.png`;
        })
        thumbImg.src = `${window.pist6.imgOrigin}/player/${rankInfo.player_id}/410x536.png`;
        const nameEle = cloneRankListItem.querySelector('.le-rank__name');
        nameEle.textContent = rankInfo.player_name;
        nameEle.parentElement.setAttribute('href', `/player/detail/?player_id=${rankInfo.player_id}`);
        cloneRankListItem.querySelector('._gear').textContent = rankInfo.gear_rate || 'ー';
        cloneRankListItem.querySelector('._time').textContent = rankInfo.total_time || 'ー';

        const countryCode = rankInfo.player_country_code;
        if (countries[countryCode]) {
          const imgEle = cloneRankListItem.querySelector('.le-rank__country-img');
          imgEle.src = `${window.pist6.imgOrigin}/national_flag/${countryCode}/data.svg`;
          imgEle.alt = countries[countryCode].ja;
        } else {
          cloneRankListItem.querySelector('.le-rank__country-flag').textContent = 'ー';
        }

        fragment.appendChild(cloneRankListItem);
      })
    });

    return new Promise(resolve => {
      Promise.all(imgLoadPromises)
        .then(() => {
          rankList.innerHTML = '';
          rankList.appendChild(fragment);

          if (t.isDiscontinuation) {
            rankList.classList.add('is-discontinuation');
            rankList.dataset.content = '中止';
          }

          rankList.classList.remove('_skelton');
          rankList.removeAttribute('aria-hidden');
          resolve();
        })
    })
  }
  const buildTimetrialRaceVideo = (movieId) => {
    if (movieId) {
      const movieStr = `<iframe class="le-movie__entity" width="560" height="315" src="https://www.youtube.com/embed/${movieId}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
      const movieContainer = t.root.querySelector('.le-movie__source');
      movieContainer.innerHTML = movieStr;
    } else {
      t.root.querySelector('.le-timetrial__movie').remove();
    }
  }

  init()
}
